import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("seo.notFound.title")}</title>
                <meta name="description" content={t("notFound.message")} />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Box
                mb={{ xs: 6, sm: 10 }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                textAlign="center"
                px={2}
            >
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: { xs: "4.5rem", sm: "6rem" },
                        fontWeight: 800,
                        lineHeight: 1,
                        color: "primary.main",
                        opacity: 0.95,
                    }}
                >
                    {t("notFound.code")}
                </Typography>
                <Typography variant="h4" fontWeight={700} color="text.primary" mt={2} gutterBottom>
                    {t("notFound.heading")}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420, mb: 4 }}>
                    {t("notFound.message")}
                </Typography>
                <Button component={Link} to="/" variant="contained" color="secondary" size="large" sx={{ px: 3, py: 1.25, borderRadius: 2, fontWeight: 700, textTransform: "none" }}>
                    {t("notFound.backHome")}
                </Button>
            </Box>
        </>
    );
};

export default NotFoundPage;
